import type { MetaFunction } from "@remix-run/cloudflare";
import { Outlet } from "@remix-run/react";
import Footer from "~/components/Footer";
import styles from "~/styles/auth.module.css";

export const meta: MetaFunction = () => [
  { title: "Prodigium Account" },
  { name: "description", content: "Prodigium Account — sign in, manage your products and preferences." },
];

export default function AccountLayout() {
  return (
    <div className={styles.layout}>
      <div className={styles.content}>
        <Outlet />
      </div>
      <Footer />
    </div>
  );
}
